module.exports = __webpack_public_path__ + "media/img/pages/companies/careerplus_de-b520b8000e257f9ff55b133130cb1cce.png";